// Append new functions to cash
$.trim = val => {
    if (val == void 0) return ""
    return  val.toString().replace(/^([\s]*)|([\s]*)$/g, '');
}
$.visible= (selector) => {
    return  $(selector).filter((index, elem )=>{
        return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
    })

};

$.map = (value, callback) => {
    return Array.prototype.map.call(value, callback)
}